import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Select from "react-select";
import Searchbox from "../../Misc/Searchbox";
import SearchListItem from "./SearchListItem";
import typedoc from "../Workdoc/typedoc";
import Datetime from "react-datetime";

let typedocClasses = typedoc
  .filter((item) => item.searchLabel)
  .map((item) => {
    return {
      value: item.key,
      label: item.searchLabel,
    };
  });

let extraClasses = [
  { value: "emergency_folder", label: "Аварийная папка" },
  { value: "techdoc", label: "Тех. документация" },
  { value: "library", label: "Библиотека" },
  { value: "staff", label: "Сотрудники" },
  { value: "maintenance", label: "Тех. обслуживания" },
  { value: "model", label: "ЗИП" },
  { value: "element", label: "Оборудование" },
  { value: "tracker", label: "Операции" }
];

let availableClasses = typedocClasses.concat(extraClasses);
let defaultClasses = availableClasses.map((item) => item.value);

export default class SearchList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.state = {
      pending: false,
      query: props.query,
      items: [],
      classes: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) {
      this.setState({ query: this.props.query }, () => this.load());
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let items = [];
    let entities =
      this.state.classes.length > 0 ? this.state.classes : defaultClasses;
    if (this.state.query) {
      items = await this.context.api.qa("/search", {
        text: this.state.query,
        entities,
      });
      items = items.filter((item) => item.id);
    }
    this.setState({ pending: false, items });
  };
  handleSearch = (query) => {
    this.setState({ query }, () => this.load());
  };

  selectChange = (value) => {
    if (Array.isArray(value)) {
      this.setState({ classes: value.map((item) => item.value) }, () =>
        this.load()
      );
    }
  };

  render() {
    return (
      <>
        <div className="card card-custom  ">
          <div className="card-header px-5 py-2">
            <div className="pt-2 d-block w-100">
              <div className="row">
                <div className="col-6">
                  <Searchbox
                    onSearch={this.handleSearch}
                    defaultText={this.state.query}
                  />
                </div>
                <div className="col-6">
                  <Select
                    value={this.context.api.getReferenceValue(
                      this.state.classes,
                      availableClasses
                    )}
                    onChange={(v) => this.selectChange(v)}
                    className="from-control react-select react-select-grey"
                    classNamePrefix="react-select-inner"
                    options={availableClasses}
                    placeholder={"Область поиска"}
                    noOptionsMessage={() => ""}
                    isClearable
                    isMulti
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card-body px-5">
            <Blocker on={this.state.pending}>
              {this.state.items.map((item) => (
                <SearchListItem key={item.id} {...item} />
              ))}
            </Blocker>
          </div>
        </div>
      </>
    );
  }
}
